export default {
  vision: "FRAUDVISION".toUpperCase(),
  thats_the_vision: "这，就是 Vision。".toUpperCase(),
  all_rights__: "  2025 FraudVision 版权所有。",
};
